export default "__VITE_ASSET__BwgjtM33__"